import React from "react";
import PropTypes from "prop-types";
import {Link} from 'react-router-dom/';

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import ReactTable from "react-table";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import moment from "moment";

export default class AdminsCustomers extends Framework.Components.Collection {
	static propTypes = {
		...Framework.Components.Collection.propTypes,
		loadCustomer: PropTypes.func.isRequired,
	};

	constructor(props) {
		let model = new API.BuildClass(Types.Customers._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 10;
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns =[
			{
				Header: "Name",
				id: "name",
				/** @param {Customers_Object} obj */
				accessor: (obj) => obj.name,
				Cell: (props) => {
					let {original} = props;

					return (
						<span>
							<Link to={`/customers/${original.pkey}`}>
								{original.name}
							</Link>
						</span>
					);
				}
			},
			{
				Header: "City",
				id: "customers_locations.city",
				/** @param {Customers_Object} obj */
				accessor: obj => (obj.customers_locationss && obj.customers_locationss.length > 0 && obj.customers_locationss[0].street_1) ? obj.customers_locationss[0].city : ''
			},
			{
				Header: "State",
				id: "customers_locations.state",
				width: 60,
				/** @param {Customers_Object} obj */
				accessor: obj => (obj.customers_locationss && obj.customers_locationss.length > 0 && obj.customers_locationss[0].street_1) ? obj.customers_locationss[0].state : ''
			},
			{
				Header: "Referred",
				accessor: "referer"
			},
			{
				Header: "Date Created",
				id: 'created',
				/** @param {Customers_Object} obj */
				accessor: obj => moment(obj.created).local().format('MM/DD/YYYY h:mm A'),
			},
		]
		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Customers')}
							{this.renderHeaderRight("Admincustomer",columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
